import {Injectable, Type} from '@angular/core';
import {DialogModalComponent} from "../../components/layout/dialog-modal/dialog-modal.component";
import {Observable} from "rxjs";
import {Dialog} from "../../interfaces/dialog/dialog";
import {DialogParams} from "../../interfaces/dialog/dialog-params";

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  dialogModalComponent: DialogModalComponent | null = null;

  constructor() {
  }

  setDialogModalComponent(dialogModalComponent: DialogModalComponent): void {
    this.dialogModalComponent = dialogModalComponent;
  }

  openDialog(componentType: Type<Dialog>, params: DialogParams): Observable<any> {
    return new Observable<any>((subscriber) => {
      this.dialogModalComponent?.open(componentType, params).subscribe((closeParams: any) => {
        subscriber.next(closeParams);
      });
    });
  }

  closeDialog(params: any = null): void {
    this.dialogModalComponent?.close(params);
  }
}
